<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" type="ball-atom" [fullScreen]="true">
    <p style="color: white"> Loading.... </p>
</ngx-spinner>
<div class="content-wrapper" style="min-height: 307px">
    <div class="card">
        <div class="card-header bg-green">
            <div style="float: left;">
                <h2><i class="fa fa-users"></i>รายการขอเกี้ยว ปี {{selecyear}}</h2>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-6">
                    <ul class="nav nav-pills mr-auto p-2">
                        <li (click)="setselect=1" class="nav-item"><a class="nav-link active" data-toggle="tab">
                                <i class="fas fa-arrow-alt-circle-right"></i> เลือกโดยโซน <span
                                    class="badge bg-warning"></span></a>
                        </li>
                        <li (click)="setselect=2" class="nav-item"><a class="nav-link" data-toggle="tab">
                                <i class="fas fa-arrow-alt-circle-right"></i> เลือกโดยวันที่อนุมัติ
                                <span class="badge bg-warning"></span>
                            </a>
                        </li>
                        <li (click)="setselect=3" class="nav-item"><a class="nav-link" data-toggle="tab">
                                <i class="fas fa-arrow-alt-circle-right"></i> เลือกโดยวันที่ขอ
                                <span class="badge bg-warning"></span>
                            </a>
                        </li>
                        <li (click)="setselect=4" class="nav-item"><a class="nav-link" data-toggle="tab">
                                <i class="fas fa-arrow-alt-circle-right"></i> เลือกโควตาชาวไร่
                                <span class="badge bg-warning"></span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row" [formGroup]="Actiocmg">
                <div class="col-md-auto">
                    <div class="input-group mb-4">
                        <span class="input-group-text" id="basic-addon1">เลือกปี</span>
                        <select class="form-select" [(ngModel)]="selecyear" [ngModelOptions]="{standalone: true}"
                            name="year">
                            <option [value]="" disabled>-- กรุณาเลือกปี --</option>
                            <option [value]="6465">ปี 64/65</option>
                            <option [value]="6566">ปี 65/66</option>
                            <option [value]="6667">ปี 66/67</option>
                            <option [value]="6768">ปี 67/68</option>
                            <option [value]="6869">ปี 68/69</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-auto" *ngIf="setselect==4">
                    <div class="input-group mb-3">
                        <span class="input-group-text" id="basic-addon1">ระบุโควตา</span>
                        <input type="text" class="form-control" placeholder="โควตา 5-6 ตัว" aria-label="Username"
                            formControlName="fmcode" name="fcode">
                        <button mat-raised-button color="primary" (click)="Loadlistaskformoney()"> ตกลง</button>
                    </div>
                </div>

                <div class="col-md-auto" *ngIf="setselect==1 || setselect==3">
                    <div class="input-group mb-3">
                        <span class="input-group-text" id="basic-addon2">เลือกสถานะ</span>
                        <select class="form-select" formControlName="doc_status" name="d_status">
                            <option value="" disabled>-- สถานะ --</option>
                            <option value="0">- ส่งคำขอจากเขต -</option>
                            <option value="1">- พนักงานสินเชื่อ -</option>
                            <option value="2">- หัวหน้าส่วน -</option>
                            <option value="8">- หัวหน้าแผนกสินเชื่อ -</option>
                            <option value="4">- อนุมัติแล้ว -</option>
                            <option value="10" selected>- ทุกสถานะ -</option>
                        </select>
                    </div>
                </div>

                <div class="col-md-auto" style="float: right;" *ngIf="setselect==1">
                    <div class="input-group mb-3">
                        <span class="input-group-text" id="basic-addon2">เลือกโซน</span>
                        <select class="form-select" formControlName="selectzone">
                            <option value="" disabled> -- กรุณาเลือกโซน --</option>
                            <option *ngFor="let item of zonecode" [ngValue]="item.SUPZONE">{{item.SUPZONE}} |
                                {{item.ZONENAME}}</option>
                        </select>
                        <button mat-raised-button color="primary" (click)="select_data()"> ตกลง</button>
                    </div>
                </div>

                <div class="col-md-auto" style="float: right;" *ngIf="setselect==2">
                    <div class="input-group mb-3">
                        <span class="input-group-text">วันที่อนุมัติ</span>
                        <input formControlName="date1" id="dateStart" type="date" class="form-control">
                        <span class="input-group-text">ถึงวันที่</span>
                        <input formControlName="date2" id="dateStop" type="date" class="form-control">
                        <button mat-raised-button color="primary" (click)="Loadlistaskformoney()"> ตกลง</button>
                    </div>
                </div>
                <div class="col-md-auto" style="float: right;" *ngIf="setselect==3">
                    <div class="input-group mb-3">
                        <span class="input-group-text">วันที่ขอ</span>
                        <input formControlName="date1" id="dateStart" type="date" class="form-control">
                        <span class="input-group-text">ถึงวันที่</span>
                        <input formControlName="date2" id="dateStop" type="date" class="form-control">
                        <button mat-raised-button color="primary" (click)="Loadlistaskformoney()"> ตกลง</button>
                    </div>
                </div>
            </div>
            <div>
                <div class="row" *ngIf="listdata != null">
                    <div class="col-md-2">
                        <button mat-raised-button color="primary" (click)="ExportTOExcel()">Export as Excel</button>
                    </div>
                    <div class="col-md-4">
                        <mat-form-field appearance="standard">
                            <mat-label>ค้นหาชื่อ หรือ เลขที่คำขอ จำนวนเงิน</mat-label>
                            <input matInput (keyup)="applyFilter($event)" placeholder="รายการที่ต้องการหา" #input>
                        </mat-form-field>
                    </div>
                </div>

                <div class="example-container mat-elevation-z8" #TABLE>
                    <table mat-table #table [dataSource]="listdata" matSort>
                        <ng-container matColumnDef="no">
                            <th mat-header-cell *matHeaderCellDef> ลำดับ </th>
                            <td mat-cell *matCellDef="let element; let i = index;">{{i+1}}</td>
                        </ng-container>
                        <ng-container matColumnDef="doc_no">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>เลขที่คำขอ</th>
                            <td mat-cell *matCellDef="let element"> {{element.docid}} </td>
                        </ng-container>
                        <ng-container matColumnDef="supportter">
                            <th mat-header-cell *matHeaderCellDef> <mat-icon>person_add</mat-icon> </th>
                            <td mat-cell *matCellDef="let element"> {{element.supcode.trim()}} </td>
                        </ng-container>
                        <ng-container matColumnDef="date">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>วันที่</th>
                            <td mat-cell *matCellDef="let element"> {{THtoLocalstring(element.datepost)}} </td>
                        </ng-container>
                        <ng-container matColumnDef="intlandno">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>แปลง</th>
                            <td mat-cell *matCellDef="let element"> {{element.intlandno}} </td>
                        </ng-container>
                        <ng-container matColumnDef="FMCODE">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>โควตา</th>
                            <td mat-cell *matCellDef="let element"> {{element.FMCODE}} </td>
                        </ng-container>
                        <ng-container matColumnDef="fullname">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>ชื่อ-นามสกุล</th>
                            <td mat-cell *matCellDef="let element"> {{element.fmname}} </td>
                        </ng-container>
                        <ng-container matColumnDef="comment1">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>เรื่องที่ขอ</th>
                            <td mat-cell *matCellDef="let element"> {{element.type_money_sub}}-{{element.comment1}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="countmoney">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>จำนวนเงิน</th>
                            <td mat-cell *matCellDef="let element"> {{element.money_amt|number}} </td>
                        </ng-container>
                        <ng-container matColumnDef="credit_approved">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>เงินที่อนุมัติ</th>
                            <td mat-cell *matCellDef="let element"> {{element.credit_approved|number}} </td>
                        </ng-container>
                        <ng-container matColumnDef="dateapprove">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>วันที่อนุมัติ</th>
                            <td mat-cell *matCellDef="let element"> {{THtoLocalstring(element.dateapprove)}} </td>
                        </ng-container>
                        <ng-container matColumnDef="datetransfer">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>วันที่โอน</th>
                            <td mat-cell *matCellDef="let element"> {{THtoLocalstring2(element.datetransfer)}} </td>
                        </ng-container>
                        <ng-container matColumnDef="bank">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>ธนาคาร</th>
                            <td mat-cell *matCellDef="let element"> {{element.bank}} </td>
                        </ng-container>
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>สถานะ</th>
                            <td mat-cell *matCellDef="let element"> {{element.docdesc}} </td>
                        </ng-container>
                        <ng-container matColumnDef="timeline">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Timeline</th>
                            <td mat-cell *matCellDef="let element">
                                <!--<button type="button" class="btn btn-primary btn-sm" (click)="Datainmodel(element.docid)" data-toggle="modal" data-target="#Timeline">
                                    <i class="far fa-clock"></i>
                                </button>-->
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displaylist ; sticky: true;"></tr>
                        <tr mat-row *matRowDef="let row; columns: displaylist;"></tr>
                    </table>
                    <mat-paginator [pageSizeOptions]="[10, 25, 50 ,100 ,250 , 500, 1000, 2000]" showFirstLastButtons
                        aria-label="Select page of periodic elements">
                    </mat-paginator>
                </div>
            </div>
        </div>
    </div>
</div>

<app-footer></app-footer>